import SPiD from 'utilities/spid'
import axios from 'axios'
import { getAddresses } from 'actions/Address'
import { getPaymentMethods } from 'actions/PaymentMethod'
import { push } from 'connected-react-router'
import jwtDecode from 'jwt-decode'
import { setCardHolderNameFromLogin } from 'actions/NewPaymentMethod'

export function userLogin(data) {
    return function (dispatch) {
        dispatch({ type: 'USER_LOGIN', payload: data })
        dispatch(setCardHolderNameFromLogin(data))
    }
}

export function userLogout() {
    return function (dispatch) {
        dispatch({ type: 'USER_LOGOUT' })
    }
}

export function userSessionChange(data) {
    return function (dispatch) {
        dispatch({ type: 'USER_SESSION_CHANGE', payload: data })
    }
}

export function validateJwt(jwt, tokenSource) {
    return function (dispatch) {
        dispatch({ type: 'VALIDATE_JWT', payload: { jwt } })
        axios
            .get(`${process.env.CORE_API}/spid/validateToken`, {
                headers: { Authorization: 'Bearer ' + jwt },
            })
            .then(() => {
                localStorage.setItem('jwt', jwt)
                const jwtData = jwtDecode(jwt)
                dispatch({
                    type: 'VALIDATE_JWT_SUCCESS',
                    payload: { jwt, jwtData, tokenSource },
                })
                dispatch(getAddresses())
                dispatch(getPaymentMethods())
            })
            .catch((err) => {
                console.error(err)
                dispatch({
                    type: 'VALIDATE_JWT_FAILED',
                    payload: { err, tokenSource },
                })
            })
    }
}

export function logout() {
    return function (dispatch) {
        if (
            window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.logout
        ) {
            // iOS
            dispatch(userLogout())
            dispatch(push('/'))
            window.webkit.messageHandlers.logout.postMessage('')
        } else if (window.AuthAndroidBridge && window.AuthAndroidBridge.logout) {
            // Android
            dispatch(userLogout())
            dispatch(push('/'))
            window.AuthAndroidBridge.logout()
        } else {
            // Web - this will end up dispatching the userLogout action
            if (window.location.origin) {
                SPiD.identity.redirectUri = window.location.origin
            }
            SPiD.identity.logout()
        }
    }
}

export function appLogin() {
    let state = window.store ? window.store.getState() : null
    let authenticateOrderKey =
        state && state.checkout.authenticateOrderKey ? state.checkout.authenticateOrderKey : null

    window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.login.postMessage({ authenticateOrderKey })

    window.AuthAndroidBridge &&
        window.AuthAndroidBridge.login &&
        window.AuthAndroidBridge.login(authenticateOrderKey)
}

export function webLogin() {
    let redirect = window.location.href

    let state = window.store ? window.store.getState() : null
    let authenticateOrderKey =
        state && state.checkout.authenticateOrderKey ? state.checkout.authenticateOrderKey : null

    let subscribePayload = JSON.stringify({
        redirectTo: redirect,
        shopId: process.env.SUBSCRIBE_SHOP_ID,
        authenticateOrderKey,
    })
    const config = {
        redirectUri: `${process.env.CORE_API}/spid/login`,
        preferPopup: false,
        newFlow: true,
        state: subscribePayload,
        scope: 'openid profile email phone address',
    }
    SPiD.identity.login(config)
}
